import { Skeleton } from '@typings';
import cx from 'classnames';

import { SkeletonBase } from '../SkeletonBase';

export const ButtonSkeleton = ({ color, size }: Skeleton.ButtonSkeleton) => (
  <SkeletonBase className={cx('min-w-8 !rounded-large', { 'h-10': size === 'large', 'h-8': size === 'medium' })} color={color} />
);
